<template>
  <div>
    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style="background-color: transparent;">
        <v-card-title v-if="smartDisplay.id != ''" class="text-h5">{{getTranslated('_editSmartDisplay')}}</v-card-title>
        <v-card-title v-else class="text-h5">{{getTranslated('_addSmartDisplay')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
            <v-text-field v-model="smartDisplay.smartDisplayName" :rules="requiredRule" :label="getTranslated('_name')"></v-text-field>
            <v-select :items="wmsInstances" v-model="smartDisplay.instanceId" item-text="instancename" item-value="id" :rules="requiredRule" :label="getTranslated('_wmsInstance')" :no-data-text="getTranslated('_selectNoData')"></v-select>
            <br>
            <v-card class="pb-5">
              <v-card-title class="text-h6">
                {{getTranslated('_board')}}
              </v-card-title>
            <v-row justify="space-between" class="mx-5">
              <v-select :items="boardTypes" v-model="smartDisplay.board.type.id" item-text="boardTypeName" item-value="id" :rules="requiredRule" :label="getTranslated('_type')" class="mx-4" style="width: 40%">
                <template slot="selection" slot-scope="data">
                  <v-icon :class="getBoardTypeIcon(data.item.id) == 'view_agenda' ? 'rotate-90' : ''">{{getBoardTypeIcon(data.item.id)}}</v-icon> <span class="ml-3">{{ data.item.boardTypeName }}</span>
                </template>
                <template slot="item" slot-scope="data">
                  <v-icon :class="getBoardTypeIcon(data.item.id) == 'view_agenda' ? 'rotate-90' : ''">{{getBoardTypeIcon(data.item.id)}}</v-icon> <v-spacer></v-spacer> {{ data.item.boardTypeName }} <v-spacer></v-spacer>
                </template>
              </v-select>
            </v-row>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="save">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel()">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { actions } from '../store/types/smartDisplayTypes'
import { actionsForSmartDisplays } from '../store/types/wmsInstanceTypes'
import { boardTypeActions } from '../store/types/boardTypeTypes'

export default {
  name: 'SmartDisplayEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    translations: Array
  },
  data () {
    return {
      valid: false,
      requiredRule: [v => !!v || this.getTranslated('_required')],
      dialogHeight: window.innerHeight,
      loading: false
    }
  },
  computed: {
    ...mapState({
      smartDisplay: state => state.smartDisplays.smartDisplay,
      boardTypes: state => state.boardTypes.boardTypesList,
      wmsInstances: state => state.wmsInstances.wmsInstanceList
    }),
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions({
      saveSmartDisplay: actions.SAVE_SMARTDISPLAY,
      clearSmartDisplay: actions.CLEAR_SMARTDISPLAY,
      getBoardTypes: boardTypeActions.GET_BOARDTYPES,
      getWmsInstances: actionsForSmartDisplays.GET_WMSINSTANCES
    }),
    async save () {
      this.loading = true
      await this.saveSmartDisplay(this.smartDisplay).then(res => {
        var notification = {
          color:
            res.request.status === 200 || res.request.status === 201
              ? 'green'
              : 'red',
          message:
            res.request.status === 200 || res.request.status === 201
              ? this.getTranslated('_smartDisplaySaved')
              : this.getTranslated('_smartDisplaySavedError')
        }
        this.loading = false
        this.$emit('saved', notification)
        this.cancel()
      })
    },
    async getBoards () {
      await this.getBoardTypes()
    },
    async getInstances () {
      await this.getWmsInstances()
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.$refs.form.reset()
      this.clearSmartDisplay()
    },
    getBoardTypeIcon (boardTypeId) {
      var icon
      switch (boardTypeId) {
        case 1:
          icon = 'web_asset'
          break
        case 2:
          icon = 'view_agenda'
          break
        case 3:
          icon = 'view_carousel'
          break
        default:
          icon = 'error'
          break
      }
      return icon
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    }
  },
  created () {
    this.getBoards()
    this.getInstances()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
